import { TField } from '../basis/types/tfield';
import i18n from '../basis/i18n/index';

export const getRepeatOptions = () => [
  { label: i18n.t('repeatNone'), value: TField.MEET_REPEAT_TYPE_NONE },
  { label: i18n.t('everyDay'), value: TField.MEET_REPEAT_TYPE_DAY },
  { label: i18n.t('everyWeek'), value: TField.MEET_REPEAT_TYPE_WEEK },
  { label: i18n.t('everyMonth'), value: TField.MEET_REPEAT_TYPE_MONTH },
  { label: i18n.t('everyYear'), value: TField.MEET_REPEAT_TYPE_YEAR },
];

// 会议自动静音选项
export const getAutoMuteOptions = () => [
  { label: i18n.t('open'), value: TField.MEET_AUTO_MUTE_OPEN },
  { label: i18n.t('close'), value: TField.MEET_AUTO_MUTE_CLOSE },
  { label: i18n.t('exceed'), value: TField.MEET_AUTO_MUTE_EXCEED },
];

// 会议匿名参会选项
export const getAnonymousOptions = () => [
  { label: i18n.t('anonymousAllow'), value: true },
  { label: i18n.t('anonymousDisallow'), value: false },
];
